module.exports = __webpack_public_path__ + "media/Bonus Coin Success.a31c6aef.mp3";